import { addMonths } from 'date-fns/addMonths';
import { parse } from 'date-fns/parse';
import { format } from 'date-fns/format';
import { getDaysInMonth } from 'date-fns/getDaysInMonth';
import { differenceInCalendarMonths } from 'date-fns/differenceInCalendarMonths';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
import { locales, validateLocale } from '../locales';
const fallback = Date.now();
// Return an array of dates as string format yyyyMMdd
const buildDaysFns = (month, weekStartsOn) => {
  const m = format(month, 'MM');
  const y = format(month, 'yyyy');
  // Find how many days in the target month.
  const daysInMonth = Number.parseInt(getDaysInMonth(month).toString(), 10);
  // What day of the week is the first day of the month.
  const dayOne = parse(`${y}${m}01`, PRICELINE_DATE_FORMAT, fallback);
  let padDays = Number.parseInt(format(dayOne, 'i'), 10);
  // Adjust for position of Sunday
  padDays -= Number.parseInt(weekStartsOn, 10);
  // Collapse empty weeks (eg First day of month is a Sunday)
  if (padDays === 7) padDays = 0;
  // Create an empty array and fill it with the days and the padding.
  const days = Array(padDays + daysInMonth).fill('');
  for (let i = padDays; i < days.length; i++) {
    const day = `${i + 1 - padDays}`;
    days[i] = `${y}${m}${day.padStart(2, '0')}`;
  }
  return days;
};
const buildMonths = (minDate, maxDate, locale) => {
  const months = [];
  const validLocale = validateLocale(locale);
  const weekStartsOn = locales[validLocale].options && locales[validLocale].options.weekStartsOn || 0;
  // Convert our start and end dates to dateObjects.
  const minUTC = parse(minDate.toString(), PRICELINE_DATE_FORMAT, fallback);
  const maxUTC = parse(maxDate.toString(), PRICELINE_DATE_FORMAT, fallback);
  // Determine our loop start and end.
  const monthsToBuild = differenceInCalendarMonths(maxUTC, minUTC);
  for (let i = 0; i <= monthsToBuild; i++) {
    const currentMonth = addMonths(minUTC, i);
    const monthIndex = Number.parseInt(format(currentMonth, 'M'), 10) - 1;
    // Build the month.
    const days = buildDaysFns(currentMonth, weekStartsOn);
    // Build the labels.
    const labels = days.map(date => date ? format(parse(date, PRICELINE_DATE_FORMAT, Date.now()), 'MMMM d, yyyy') : '');
    months.push({
      monthIndex,
      month: `${format(currentMonth, 'MM')}`,
      year: `${format(currentMonth, 'yyyy')}`,
      days,
      labels
    });
  }
  return months;
};
export default buildMonths;